import type { LeadStatus } from "../../types/api";
import { statusLabels } from "../../lib/format";

export function StatusBadge({ status }: { status: LeadStatus }) {
  return (
    <span className={`status-badge status-badge--${status.toLowerCase()}`}>
      <i aria-hidden="true" />
      {statusLabels[status]}
    </span>
  );
}

export function RedemptionBadge({ status }: { status: string }) {
  const labels: Record<string, string> = {
    REQUESTED: "Solicitado",
    APPROVED: "Aprovado",
    FULFILLED: "Entregue",
    REJECTED: "Recusado",
    CANCELLED: "Cancelado",
  };
  return (
    <span className={`status-badge status-badge--${status.toLowerCase()}`}>
      <i aria-hidden="true" />
      {labels[status] ?? status}
    </span>
  );
}
